import { render } from "./blog-4.vue?vue&type=template&id=a9a66e36"
import script from "./blog-4.vue?vue&type=script&lang=js"
export * from "./blog-4.vue?vue&type=script&lang=js"

import "./blog-4.vue?vue&type=style&index=0&id=a9a66e36&lang=less"

import exportComponent from "/var/jenkins_home/workspace/give-circle-intro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__